import React, { useState } from "react";
import AuthLayout from "../../Components/Layouts/AuthLayout";
import { useAppSelector } from "../../app/store";
import { RegisterCompany } from "../../types";
import axios from "axios";
import { Button, Card, CardBody, Col, Row } from "react-bootstrap";
import Cards from "../Charts/Cards";
import PieChart from "../Charts/PieCharts";

const Dashboard = () => {
  const { user } = useAppSelector(
    (state) => state.auth as { user: RegisterCompany | null }
  );

  return (
    <>
      <AuthLayout>
        <Card className="border-0">
          <Card.Body>
            <Row>
              <Col md={3} sm={12}>
                <h3>Dashboard</h3>
              </Col>
              <Col md={9} sm={12}>
                <div className="float-end">
                  <form>
                    <Row className="g-3 align-items-center">
                      <div className="col-auto">from</div>
                      <div className="col-auto">
                        <input type="date" className="form-control" />
                      </div>
                      <div className="col-auto">to</div>
                      <div className="col-auto">
                        <input type="date" className="form-control" />
                      </div>
                      <div className="col-auto">
                        <Button className="btn btn-secondary">
                          <i className="text-white bi bi-download"></i>
                        </Button>
                      </div>
                    </Row>
                  </form>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <Row className="mt-4">
          <Col md={8} sm={12}>
            <Cards />
          </Col>
          <Col md={4} sm={12}>
            <Card className="border-0">
              <CardBody>
                <PieChart />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </AuthLayout>
    </>
  );
};

export default Dashboard;
